import React, { useEffect, useState } from "react";
import axios from "axios";
import { Navbar } from "./Navbar";
import { Helmet } from "react-helmet-async";
import { FiMapPin, FiHome, FiSearch, FiShield } from 'react-icons/fi';
import { useParams } from 'react-router-dom';

export const Onlyplotsfecting = () => {
    const { status } = useParams();
    const plottype = status;
    const [plots, setPlots] = useState([]);


    useEffect(() => {
        axios.get(`/api/fetch-plots/${encodeURIComponent(plottype)}`)
        .then((res) => {
            console.log("Fetched plots:", res.data); // <-- Add this line
            setPlots(res.data);
        })
            .catch((err) => console.error("Error fetching residential plots:", err));
    }, [plottype]);

    return (
        <div>
            <Helmet>
                <title>{`${plottype} Plots for Sale | 24Krealtors`}</title>
                <meta
                    name="description"
                    content={`Find premium ${plottype} plots in Chennai. Get verified listings, exact locations, and pricing details.`}
                />
            </Helmet>

            <Navbar />
            <div className="margin"></div>
            <div className="topic1">
                <h3 className="topic-title">
                    <span className="diamond"></span>{plottype} Plots<span className="diamond"></span>
                </h3>

                <div className="projects-grid">
                    {Array.isArray(plots) && plots.map((project) => (
                        <a
                            key={project.projectid}
                            href={`/new-project/${project.projectid}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="property-card1"
                            style={{ textDecoration: 'none', color: 'inherit' }}
                        >
                            <div className="card-image">
                                <img src={project.image} alt={project.bpn} />
                                <span className="badge verified "><FiShield /> Verified</span>
                                <span className="badge status">Under Construction</span>
                            </div>
                            <div className="card-content">
                                <h3>{project.bpn}</h3>
                                <div className="flex">
                                <p className="developer">{project.builder}</p> |
                                <p className="devr">{project.property_type}</p>
                                </div>
                                <p className="icon-text">
                                    <FiMapPin /> {project.city}, {project.locality}
                                </p>
                                <div className='flex'>
                                    <p className="icon-text">
                                        <FiHome /> {project.bhk_range
                                            .replace(/bhk/gi, '')
                                            .split(',')
                                            .join('&') + ' BHK'}
                                    </p>
                                    <p className="icon-text">
                                        ₹{project.min_price} - ₹{project.max_price}
                                    </p>
                                </div>
                                <div className="card-actions">
                                    <button className="btn view">
                                        <FiSearch /> View Details
                                    </button>

                                </div>
                            </div>
                        </a>
                    ))}
                </div>
            </div>
        </div>
    )
}
